import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { unsafeUseFormReturnSubset } from '@ipfabric/ui-components/utils/formSnippets/unsafeUseFormReturnSubset';
import { PrivilegedCredentials } from '../../../components/Authentication/PrivilegedCredentials';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import {
  type PrivilegedCredentialsFieldValues,
  storedPrivilegedCredentials,
} from '../../../snippets/storedPrivilegedCredentials';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const privilegedCredentialsGroup = createFormSnippetGroup({
  snippets: {
    storedPrivilegedCredentials,
  },
  render: ({ renderSnippet, form }) => (
    <SearchableSection
      className='flex flex-1 flex-col'
      wrapperClassName='flex flex-1 flex-col'
      id='privileged-credentials'
      searchTerms={['Enable mode passwords']}
    >
      <PrivilegedCredentials
        form={unsafeUseFormReturnSubset(form)<
          keyof PrivilegedCredentialsFieldValues
        >()}
        renderSnippet={renderSnippet}
      />
    </SearchableSection>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('authentication');
    control.setAuthenticationSubTab('privilegedCredentials');
  },
});
